import { Injectable } from '@angular/core';
// import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { HttpService } from './services/http.service';

@Injectable({
  providedIn: 'root'
})
export class GetApiService {

  loggedInUser: any = null;

  constructor(
    private http:HttpClient,
    private authService: AuthService,
    private httpService: HttpService
  ) { }
 
  apicall() {
    return this.http.get(`${environment.apiUrl}/api/favouriteList1`);
  }

  getDatabricksQueryExecuted() {
    return this.http.get(`${environment.apiUrl}/api/data`);
  }

  // getDownload()
  // {
  //   return this.http.get(`${environment.apiUrl}/api/getDownload`,{
  //     headers
  //   })
  // }

  saveFavourites(favouriteObject:any){

    var StringValue = favouriteObject.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)
    favouriteObject['x-access-token'] = encoded;

    return this.http.post(`${environment.apiUrl}/api/saveFavourites`,favouriteObject);
  }

  getFavorites(userEmail:any){
    var StringValue = userEmail.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)
    userEmail['x-access-token'] = encoded;

    return this.http.post(`${environment.apiUrl}/api/getFavorites`,userEmail);
  }

  getOtherUsersFavorites(userEmail:any){

    var StringValue = userEmail.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)
    userEmail['x-access-token'] = encoded;

    return this.http.post(`${environment.apiUrl}/api/getOtherUsersFavorites`,userEmail);
  }

  getScenarioMapping(){
    this.authService.activeUser.subscribe((res) => {
      this.loggedInUser = res;   
    },
    (error)=>{
      console.log(error);
    });
    
    var StringValue = this.loggedInUser.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)

    const headers = new HttpHeaders()
      .set('userEmail',this.loggedInUser.username)
      .set('x-access-token',encoded);

    return this.http.get(`${environment.apiUrl}/api/getScenarioMapping`, {'headers':headers});
  }

  postExportBasicTemplate(exportBasic:any){
    var StringValue = exportBasic.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)
    exportBasic['x-access-token'] = encoded;

    return this.http.post(`${environment.apiUrl}/api/saveExportBasic`,exportBasic);
  }

  postExportAdvancedTemplate(exportAdvanced:any){
    var StringValue = exportAdvanced.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)
    exportAdvanced['x-access-token'] = encoded;

    return this.http.post(`${environment.apiUrl}/api/saveExportAdvanced`,exportAdvanced);
  }

  getExportAdvanced(userEmail:any){
    var StringValue = userEmail.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)
    userEmail['x-access-token'] = encoded;

    return this.http.post(`${environment.apiUrl}/api/getExportAdvanced`,userEmail);
  }

  postFeedback(feedback:any){
    var StringValue = feedback.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)
    feedback['x-access-token'] = encoded;

    return this.http.post(`${environment.apiUrl}/api/saveFeedback`,feedback);
  }

  postLoggedInData(loggedIn:any){
    var StringValue = loggedIn.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)
    loggedIn['x-access-token'] = encoded;

    return this.http.post(`${environment.apiUrl}/api/saveLoggenInData`,loggedIn);
  }

  getThumbnails(){
    this.authService.activeUser.subscribe((res) => {
      this.loggedInUser = res;   
    },
    (error)=>{
      console.log(error);
    });
    
    var StringValue = this.loggedInUser.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)

    const headers = new HttpHeaders()
      .set('userEmail',this.loggedInUser.username)
      .set('x-access-token',encoded);
      
    return this.http.get(`${environment.apiUrl}/api/getThumbnails`,{'headers':headers});
  }

  getFeedback(){
    this.authService.activeUser.subscribe((res) => {
      this.loggedInUser = res;   
    },
    (error)=>{
      console.log(error);
    });
    var StringValue = this.loggedInUser.userEmail+environment.azure.clientId;
    const encoded = btoa(StringValue)
    const headers = new HttpHeaders()
      .set('userEmail',this.loggedInUser.username)
      .set('x-access-token',encoded);
    return this.http.get(`${environment.apiUrl}/api/getFeedBackReport`,{'headers':headers});
  }
fetchData(filters:any)
  {
     console.log("data api call"+filters);
    this.authService.activeUser.subscribe((res) => {
        this.loggedInUser = res;  
      },
      (error)=>{
        console.log(error);
      });
    //   var StringValue = this.loggedInUser.username+environment.azure.clientId;
    //   const encoded = btoa(StringValue)
    //   const headers = new HttpHeaders()
    //     .set('userEmail',this.loggedInUser.username)
    //     .set('x-access-token',encoded);
    var StringValue = this.loggedInUser.username+environment.azure.clientId;
    const encoded = btoa(StringValue)
    filters['x-access-token'] = encoded;
    filters['userEmail'] = this.loggedInUser.username;
    //return this.http.post(`${url}/api/getDataBricksQueryExecuted`,filters);
    return this.http.post(`${environment.apiUrl}/api/getDataBricksQueryExecuted`,filters,{responseType:'blob'});
    // return this.http.get(`${environment.apiUrl}/api/getDownload`,{responseType:'blob'})
    // this.getDownload();
  
  }

  getAdgroupExtractionByEmail(userEmail: string): Observable<any> {
    const params = new HttpParams().set('userEmail', userEmail);
    return this.http.get(`${environment.apiUrl}/api/getAdgroupExtraction`, { params });
  }

  getAdgroupExtraction(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/getAdgroupExtraction`);
  }


  getMetadataForUser(userId: string): Observable<any> {
    return this.authService.activeUser.pipe(
        take(1),
        switchMap((res) => {

            const stringValue = res.username + environment.azure.clientId;
            const encoded = btoa(stringValue);

            const headers = new HttpHeaders({
                "x-access-token": encoded,
                "userEmail": res.username
            });

            return this.http.get(
                `${environment.apiUrl}/api/getMetadataForUser?userId=${userId}`,
                { headers }
            );
        })
    );
}

  getRowCountFromDatabricks(data: any): Observable<any> {
    return this.authService.activeUser.pipe(
      take(1), // Get the first emitted value and complete
      switchMap((res) => {
        this.loggedInUser = res;
  
        const stringValue = this.loggedInUser.username + environment.azure.clientId;
        const encoded = btoa(stringValue);
  
        const headers = new HttpHeaders({
          'x-access-token': encoded,
          'userEmail': this.loggedInUser.username,
        });
  
        return this.http.post(`${environment.apiUrl}/api/getRowCountFromDatabricks`, data, { headers, responseType:'json' })
  .pipe(
    catchError(error => {
      console.error("API Error:", error);
      return throwError(() => error);
    })
  );
      })
    );
  }
  
  downloadFile(filePath: any) {
    var StringValue = filePath.userEmail+environment.azure.clientId;
      const encoded = btoa(StringValue)
      filePath['x-access-token'] = encoded;
  
    return this.http.post(`${environment.apiUrl}/api/getDownloadcsv`,filePath,{responseType:'blob'})
  }

getDownload()
{
  return this.http.get(`${environment.apiUrl}/api/getDownload`,{responseType:'blob'})
}

}
